<template>
  <div class="c-batch-table">
    <Spin size="large" fix v-if="loading" />
    <el-table ref="table" height="100%" border :data="data" @selection-change="handleSelectionChange">
      <el-table-column type="selection" :fixed="true" width="39"></el-table-column>
      <el-table-column prop="index" :fixed="true" label="序号" width="45">
        <template slot-scope="scope">
          <span>{{ scope.row['index'] + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="plan" :fixed="true" width="340">
        <template slot="header">
          <span>计划</span>
          <ul class="m-dynamic">
            <li v-for="(word, i) in dynwords" :key="i">
              <a href="javascript:;" @click.stop="appendTrend(word)">+{{ word }}</a>
            </li>
          </ul>
        </template>
        <template slot-scope="scope">
          <input-len
            :ref="`planinput${scope.row['index']}`"
            v-model="scope.row['plan']"
            placeholder="最大90个字符，1个中文等于2个字符"
            width="280"
            :max="90"
            :dyn-pos="scope.row['dynpos']"
            @on-focus="focusPlan(scope.row['index'])"
            @on-blur="blurPlan"
            @on-del-trend="$emit('on-delete-trend', scope.row['index'])"
            @change="changePlanName(scope.row['index'], ...arguments)"
          />
          <dd class="dynamic-error g-error-text" v-html="scope.row['dynerr']"></dd>
        </template>
      </el-table-column>
      <!-- 广告账号 -->
      <el-table-column width="126">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="accountAll" @on-change="selectAll('account', ...arguments)">计划账号</Checkbox>
            <Button @click="handleBatch('account')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_account']" @on-change="changeAccount(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('account', scope.row['index'])">{{ scope.row['account'] }}</a>
        </template>
      </el-table-column>
      <!-- 广告组 -->
      <el-table-column width="220" v-if="campagin">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="campaignAll" @on-change="selectAll('campaign', ...arguments)">计划组</Checkbox>
            <Button @click="handleBatch('campaign')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_campaign']" @on-change="changeCampaign(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('campaign', scope.row['index'])">{{ scope.row['campaign'] || '请配置计划组' }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="target" width="126">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="targetAll" @on-change="selectAll('target', ...arguments)">定向包</Checkbox>
            <Button @click="handleBatch('target')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_target']" @on-change="changeTarget(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('target', scope.row['index'])">{{ scope.row['target'] }}</a>
        </template>
      </el-table-column>
      <el-table-column width="158">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="budgetAll" @on-change="selectAll('budget', ...arguments)">预算</Checkbox>
            <Button @click="handleBatch('budget')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_budget']" @on-change="changeBudget(scope.row['index'], ...arguments)" />
          <RadioGroup v-model="scope.row.budgetMode" vertical size="small" @on-change="changeBudgetInput(scope.row['index'], ...arguments)">
            <Radio label="NONE"><span>不限</span></Radio>
            <Radio label="BUDGET" :disabled="isNobid">
              <InputNumber
                :value="scope.row['budget']"
                :min="100"
                :max="100000000"
                :step="100"
                :precision="3"
                :disabled="scope.row.budgetMode === 'NONE'"
                :active-change="false"
                size="small"
                placeholder="请输入预算金额"
                style="width: 80px"
                @on-blur="$emit('blur-budget', scope.row['index'])"
                @on-change="changeBudgetInput(scope.row['index'], ...arguments)"
              />
            </Radio>
          </RadioGroup>
        </template>
      </el-table-column>
      <el-table-column width="126">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="retargetAll" @on-change="selectAll('retarget', ...arguments)">人群包(选填)</Checkbox>
            <Button @click="handleBatch('retarget')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_retarget']" @on-change="changeReTarget(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('retarget', scope.row['index'])">{{ scope.row['retarget'] }}</a>
        </template>
      </el-table-column>

      <el-table-column width="126">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="creativeAll" @on-change="selectAll('creative', ...arguments)">创意组</Checkbox>
            <Button @click="handleBatch('creative')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_creative']" @on-change="changeCreative(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('creative', scope.row['index'])">{{ scope.row['creative'] }}</a>
        </template>
      </el-table-column>

      <el-table-column width="126" v-if="hasCustomUnitType">
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="nativeAll" @on-change="selectAll('native', ...arguments)">原生计划</Checkbox>
            <Button @click="handleBatch('native')">批量设置</Button>
          </div>
        </template>
        <!-- 通过判断scope.row.native，是否显示原生广告配置,程序化不显示 -->
        <template slot-scope="scope" v-if="scope.row.native">
          <Checkbox v-model="scope.row['_native']" @on-change="changeNative(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatch('native', scope.row['index'])">{{ scope.row['native'] }}</a>
        </template>
      </el-table-column>

      <template v-if="!isUnion">
        <el-table-column width="150">
          <template slot="header">
            <div class="c-custom-header">
              <Checkbox :value="profileAll" @on-change="selectAll('profile', ...arguments)">高级创意</Checkbox>
              <Button @click="handleBatch('profile')">批量设置</Button>
            </div>
          </template>
          <template slot-scope="scope">
            <Checkbox
              v-model="scope.row['_profile']"
              :disabled="scope.row['profile'] === '禁止启用'"
              @on-change="changeProfile(scope.row['index'], ...arguments)"
            />
            <span v-if="scope.row['profile'] === '禁止启用'" style="color: #dbdbdb; cursor: not-allowed">{{ scope.row['profile'] }}</span>
            <a href="javascript:;" v-else @click="handleBatch('profile', scope.row['index'])">{{ scope.row['profile'] }}</a>
          </template>
        </el-table-column>
        <el-table-column width="150" show-overflow-tooltip>
          <template slot="header">
            <div class="c-custom-header">
              <Checkbox :value="playAll" @on-change="selectAll('play', ...arguments)">试玩素材（选填）</Checkbox>
              <Button @click="handleBatch('play')">批量设置</Button>
            </div>
          </template>
          <template slot-scope="scope">
            <Checkbox v-model="scope.row['_play']" @on-change="changePlay(scope.row['index'], ...arguments)" />
            <a href="javascript:;" @click="handleBatch('play', scope.row['index'])">{{ scope.row['play'] }}</a>
          </template>
        </el-table-column>
      </template>
      <!-- 安卓原生落地页 v-if="appType" -->
      <el-table-column v-if="false" width="136" show-overflow-tooltip>
        <template slot="header">
          <div class="c-custom-header">
            <Checkbox :value="pagespecAll" @on-change="selectAll('pagespec', ...arguments)">{{ '落地页（选填）' }}</Checkbox>
            <Button @click="handleBatch('pagespec')">批量设置</Button>
          </div>
        </template>
        <template slot-scope="scope">
          <Checkbox v-model="scope.row['_pagespec']" @on-change="changePagespec(scope.row['index'], ...arguments)" />
          <a href="javascript:;" @click="handleBatchUrl('pagespec', scope.row['index'])" @dblclick="showUrl(scope.row['pagespec'])">{{
            scope.row['pagespec']
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="control" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="$emit('on-delete', scope.row['index'])" class="c-control-margin">删除</el-button>
          <el-button
            type="text"
            size="small"
            :disabled="deliveryMethod === 3"
            @click="$emit('on-copy', scope.$index)"
            class="c-control-margin"
            >复制</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
import InputLen from '@/components/input/input-len'
import { getSession } from '@/common/js/api'
let DTIME = null
export default {
  name: 'betchKSTable',
  components: { InputLen },
  props: {
    data: {
      type: Array,
      required: true
    },
    campagin: {
      type: Boolean
    },
    appType: {
      type: Boolean
    },
    isUnion: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    dynwords: {
      type: Array,
      required: true
    }
  },
  computed: {
    // 是否显示原生广告列，如果ret.native 不为空,则显示
    hasCustomUnitType() {
      return this.data.some((ret) => !!ret.native)
    },
    accountAll() {
      return this.data.every((ret) => ret && ret._account)
    },
    campaignAll() {
      return this.data.every((ret) => ret && ret._campaign)
    },
    targetAll() {
      return this.data.every((ret) => ret && ret._target)
    },
    retargetAll() {
      return this.data.every((ret) => ret && ret._retarget)
    },
    creativeAll() {
      return this.data.every((ret) => ret && ret._creative)
    },
    nativeAll() {
      return this.data.every((ret) => ret && ret._native)
    },
    pagespecAll() {
      return this.data.every((ret) => ret && ret._pagespec)
    },
    profileAll() {
      return this.data.filter((ret) => ret.profile !== '禁止启用').every((ret) => ret && ret._profile)
    },
    playAll() {
      return this.data.every((ret) => ret && ret._play)
    },
    budgetAll() {
      return this.data.every((ret) => ret && ret._budget)
    },
    bidAll() {
      return this.data.every((ret) => ret && ret._bid)
    },
    isNobid() {
      // 判断是否是最大转化
      if (getSession('bid_type')) return getSession('bid_type').bid_type === 1
      else if (getSession('campaign_params')) return getSession('campaign_params').bid_type === 1
      else return false
    }
  },
  data() {
    return {
      deliveryMethod: 1
    }
  },
  created() {
    this.deliveryMethod = Number(getSession('deliveryMethod'))
  },
  methods: {
    selectAll() {
      const type = arguments[0]
      const val = arguments[1]
      this.$emit('on-select-all', { type, val })
    },
    changeNativeAd() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'native', val: [index, bool] })
    },
    changeTarget() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'target', val: [index, bool] })
    },
    changeAccount() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'account', val: [index, bool] })
    },
    changeCampaign() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'campaign', val: [index, bool] })
    },
    changeReTarget() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'retarget', val: [index, bool] })
    },
    changeCreative() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'creative', val: [index, bool] })
    },

    changeNative() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'native', val: [index, bool] })
    },
    changePagespec() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'pagespec', val: [index, bool] })
    },
    changeProfile() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'profile', val: [index, bool] })
    },
    changePlay() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'play', val: [index, bool] })
    },
    changeBudget() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'budget', val: [index, bool] })
    },
    changeBid() {
      const index = arguments[0]
      const bool = arguments[1]
      this.$emit('on-select', { type: 'bid', val: [index, bool] })
    },
    changePlanName() {
      const index = arguments[0]
      const value = arguments[1]
      this.$emit('on-change', [index, value])
    },
    handleSelectionChange(selection) {
      this.$emit('on-selection', selection)
    },
    handleBatch(type, index) {
      this.$emit('on-batch', [type, index])
    },
    handleBatchUrl(type, index) {
      clearTimeout(DTIME)
      DTIME = setTimeout(() => {
        this.handleBatch(type, index)
      }, 300) // 300 单击事件
    },
    changeBudgetInput() {
      const index = arguments[0]
      const val = arguments[1]
      this.$emit('on-batch', ['budget', index, val])
    },
    showUrl(name) {
      clearTimeout(DTIME) // 清除
      if (name.includes('未配置')) return
      window.open(name, '_blank')
    },
    appendTrend(word) {
      if (typeof this.scopeIndex !== 'number') {
        this.$Message.error('请先确认插入动态词的位置')
        return
      }
      this.$emit('on-trend', [this.scopeIndex, word, this.selectionStart])
      // this.$refs[`planinput${this.scopeIndex}`].focus()
    },
    focusPlan(index) {
      this.scopeIndex = index
      if (DTIME) clearTimeout(DTIME)
    },
    blurPlan(start) {
      this.selectionStart = start
      DTIME = setTimeout(() => {
        this.$emit('on-blur', this.scopeIndex)
        timeout().then(() => {
          this.scopeIndex = null
        })
      }, 600)
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-batch-table {
  width: 100%;
  height: calc(100% - 84px);

  .c-custom-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 8px;
  }

  .bid-cell-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .ivu-checkbox-wrapper {
    margin-right: 0;
  }

  .dynamic-error {
    margin: 0;
  }

  .m-dynamic {
    padding-left: 10px;
    margin: 0;

    li {
      display: inline-block;
      margin-right: 12px;
    }
  }

  ::v-deep .el-table .cell {
    line-height: 1.2;
  }

  ::v-deep .el-table th .cell {
    max-height: unset !important;
  }

  ::v-deep .ivu-radio-wrapper {
    text-align: left;
  }

  ::v-deep .ivu-radio-group-vertical .ivu-radio-wrapper {
    height: 24px;
    line-height: 23px;
  }
}
</style>
